<template>
  <div class="advice-accordion-item">
    <button
      class="advice-accordion-toggle"
      :aria-expanded="isOpen"
      @click="$emit('toggle')"
    >
      <strong>{{ title }}</strong>
      <i class="material-icons advice-accordion-icon">
        {{ isOpen ? 'remove' : 'add' }}
      </i>
    </button>

    <b-collapse :visible="isOpen" role="tabpanel">
      <div class="advice-accordion-body">
        <slot />
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'AdviceAccordion',
  props: {
    title: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
}
</script>
